<template>
    <div class="content-item" :style="'margin-top: ' + contentMarginTop + 'px'">
        <div class="edge-line"></div>
        <div class="wrapper" :class="noPadding ? 'no-padding' : ''">
            <div class="header" v-if="title">
                <div class="title">
                    {{ title }}
                </div>
                <div class="line-arrow">
                    <div class="line"></div>
                </div>
            </div>
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['title', 'marginTop', 'noPadding'],
        computed: {
            contentMarginTop() {
                if (this.marginTop) {
                    return this.marginTop;
                } else {
                    return 0;
                }
            }
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .content-item {
        width: 1080px;
        min-height: 200px;
        margin: 30px auto;
        background: #fff;
        border-top: 7px solid $orange-color;
        border-left: 1px solid #bdbdbd;
        border-right: 1px solid #bdbdbd;
        box-shadow: 0 2px 6px #ccc;
        position: relative;
        .edge-line {
            font-size: 0;
            line-height: 0;
            margin-left: 35%;
            border-top: 5px solid $orange-color;
            border-left: 20px solid transparent;
            box-sizing: border-box;
        }
        .wrapper {
            width: 100%;
            padding: 30px;
            box-sizing: border-box;
        }
        .no-padding {
            padding: 0 !important;
            margin-top: -5px !important;
        }
    }

    .header {
        width: 100%;
        height: 30px;
        @include flex-row-center;
        margin-bottom: 35px;
        .item-icon {
            width: 30px;
            @include flex-grow(0);
        }
        .title {
            font-size: 30px;
            font-weight: bold;
            color: $orange-color;
            height: 42px;
            line-height: 42px;
            @include flex-grow(0);
            &::before {
                content: ' ';
                display: inline-block;
                width: 17.68px;
                height: 17.68px;
                transform: rotate(45deg);
                background: $orange-color;
                margin: 3px 7px 3px;
            }
        }
        .line-arrow {
            @include flex-grow(1);
            @include flex-row-center;
            .line {
                height: 1px;
                width: 100px;
                margin: 0 5px;
                background: $orange-color;
                @include flex-grow(1);
            }
            .arrow {
                width: 32px;
                height: 24px;
                @include flex-grow(0);
                cursor: pointer;
                background: url(../../../static/img/partial/right_arrows.png);
            }
        }
    }

    .content {
        width: 100%;
        margin: 0 auto;
        box-sizing: border-box;
    }
</style>


// WEBPACK FOOTER //
// ContentItem.vue?7d5e6fc8